/* Product-card alternate media is non-critical: load it near the viewport or on visitor intent. */
(function () {
  'use strict';

  Nowar.register('product-card-hover-images', '.pcard[data-hover-image]', function(card, signal) {
    var image = card.querySelector('img[data-hover-src]');
    if (!image) return;

    var loaded = false;
    var observer = null;

    function markReady() {
      card.classList.add('pcard--hover-ready');
    }

    function loadHoverImage() {
      if (loaded) return;
      loaded = true;

      image.addEventListener('load', markReady, {once: true});
      image.src = image.dataset.hoverSrc;
      image.srcset = image.dataset.hoverSrcset;
      image.sizes = image.dataset.hoverSizes;

      if (image.complete) markReady();
      if (observer) observer.disconnect();
    }

    card.addEventListener('pointerenter', loadHoverImage, {once: true, signal: signal});
    card.addEventListener('focusin', loadHoverImage, {once: true, signal: signal});
    card.addEventListener('touchstart', loadHoverImage, {once: true, passive: true, signal: signal});

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        if (entries.some(function(entry) { return entry.isIntersecting; })) loadHoverImage();
      }, {rootMargin: '300px 0px'});
      observer.observe(card);
    }

    return function() {
      if (observer) observer.disconnect();
    };
  });
})();
